<script setup lang="ts">
import PageHeader from './components/general/PageHeader.vue';
import PageFooter from './components/general/PageFooter.vue';
import { ref, computed, watch, onMounted } from 'vue';
import axiosInstance from './plugins/axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useFlagStore } from './store/flagStore';
import { useRoute } from 'vue-router';
import { useUserVariablesStore } from './store/userVariables';
import TabMenu from './components/custom/TabMenu.vue';
import { useHead } from '@unhead/vue'


const route = useRoute()
const userVariablesStore = useUserVariablesStore();
const translationIsLoading = ref(true);
const defaultLanguage = ref('en');
const languageCodes = ref<string[]>([]);
const currentLanguage = ref<string>(route.query.lang as string || defaultLanguage.value);
const uiBlocked = ref(false)
const flagDialogVisible = ref(false);
const flagStore = useFlagStore();
const settings = ref([]);
const isAuthenticated = ref(false);
const allFlagsSummary = computed(() => flagStore.getAllFlagsSummary);
const adminItems = ref([
  {
    label: 'Flags',
    icon: 'flag',
    command: () => {
      flagDialogVisible.value = true
    }
  },
])

const getSettings = () => {
  axiosInstance.get('/settings')
    .then((response) => {
      settings.value = response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};


const checkIfAuthenticated = async () => {
  const res = await axiosInstance.get('/user/isAuthenticated', {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });
  isAuthenticated.value = res.data
}

watch(
  () => route.query.lang,
  async (newLang: any) => {
    if (newLang) {
      currentLanguage.value = newLang;
      document.documentElement.lang = newLang;

    }
  }
);


const initPage = async () => {
  await userVariablesStore.loadLanguageData(currentLanguage.value || defaultLanguage.value);
  languageCodes.value = userVariablesStore.allLanguageCodes;
  translationIsLoading.value = false;
  userVariablesStore.setLanguage(currentLanguage.value || defaultLanguage.value);
  await getSettings();

  await flagStore.initializeStore();
  if (localStorage.token) {
    await checkIfAuthenticated();
  }
};



onMounted(async () => {
  await initPage();

});


</script>

<template>
  <div>
    <BlockUI :blocked="uiBlocked" fullScreen />
    <div id="normal-content" class="normal-content">
      <page-header></page-header> 
      <!---<tab-menu></tab-menu>-->
      <div class="content-view">
        <router-view></router-view>
      </div>
      <page-footer></page-footer>
    </div>


    <!-- Admin Flag Modal -->
    <Dialog v-model:visible="flagDialogVisible" modal header="Flags State" :style="{ width: '40rem' }">
      <template #header>
        <div class="inline-flex align-items-center justify-content-center gap-2">
          <font-awesome-icon :icon="['fas', 'flag']" />
          <span class="font-bold white-space-nowrap">Flags State</span>
        </div>
      </template>
      <div class="p-fluid">
        <div v-for="flag in allFlagsSummary" :key="flag.name" class="field justify-content-between flex">
          <label class="col-10" :for="flag.name">{{ flag.name }}</label>
          <Tag v-if="flag.currentValue" class="col-2" severity="success" :id="flag.name" :value="flag.currentValue"
            readonly />
          <Tag v-if="!flag.currentValue" class="col-2" severity="danger" :id="flag.name" :value="flag.currentValue"
            readonly />
        </div>
      </div>
      <template #footer>
        <Button label="Schließen" icon="pi pi-times" @click="flagDialogVisible = false" />
      </template>
    </Dialog>

    <SpeedDial v-if="isAuthenticated" :model="adminItems" direction="up" :transitionDelay="80"
      :style="{ position: 'fixed' }" pt:menuitem="m-2" style="color: white !important">
      <template #button="{ toggleCallback }">
        <Button rounded class="border" @click="toggleCallback">
          <FontAwesomeIcon icon="cog" />
        </Button>
      </template>
      <template #item="{ item, toggleCallback }">
        <div
          class="flex flex-col items-center justify-between gap-2 p-2 border rounded border-surface-200 dark:border-surface-700 w-20 cursor-pointer"
          @click="toggleCallback">
          <span>
            <FontAwesomeIcon :icon="item.icon"></FontAwesomeIcon>
          </span>
        </div>
      </template>
    </SpeedDial>
  </div>
</template>


<style scoped></style>
